module.exports = __webpack_public_path__ + "static/img/card-gray.8809e5cd.png";